class UpsellOptions extends HTMLElement {
    constructor() {
        super();
        this._parent = this.closest('.cart__item');
        this.button = this._parent.querySelector('[data-add-to-cart]');
        this.select = this.querySelector('select');
        this.init();
    }

    init(){
        this.select.addEventListener('change', () => {
            this.button.setAttribute('data-product-id', this.select.value)
        })
    }

}
customElements.define('upsell-option', UpsellOptions);

window.addEventListener('SCE:add', (event) => {
  console.log('cart event =>', event);
})
window.addEventListener('SCE:update', (event) => {
  console.log('cart event =>', event);
})
window.addEventListener('SCE:change', (event) => {
  console.log('cart event =>', event);
})